import React, { useRef } from 'react';
import 'ol/ol.css';
import { MapProvider } from '@/providers/MapProvider';
import { useMapInstance } from '../hooks/useMapInstance';
import { MapSidebar } from './MapSidebar';
import { AssetDetailsModal } from './AssetDetailsModal';
import { MapControls } from './MapControls';
import { MapSearchComponent } from './MapSearchComponent';
import '../../MapComponent.css';
import { MapInstructionOverlay } from './MapInstructionOverlay';
import { useMapStore } from '@/stores/mapStore';
import { useInitialMapLayers } from '../hooks/useInitialMapLayers';
import { MapLayerManager } from './MapLayerManager';
import { FieldNotePopup } from './popups/FieldNotePopup';
import { FeatureInfoPopup } from './popups/FeatureInfoPopup';
import { RedlineAttributePopup } from './popups/RedlinePopupForm';
import { cn } from '@/lib/utils';
import { useMapClickHandler } from '../hooks/useMapClickHandler';
import { FeatureSelectionManager } from './FeatureSelectionManager';
import { useCorrectionOverlaySync } from '../hooks/useCorrectionOverlaySync';

const MapView = () => {
  // Global map sidebar handlers
  const sidebarOpen = useMapStore((state) => state.sidebarOpen);
  const toggleSidebar = useMapStore((state) => state.toggleSidebar);

  // Get map refs
  const mapTargetRef = useRef<HTMLDivElement | null>(null);
  const map = useMapInstance(mapTargetRef);

  useInitialMapLayers();

  useMapClickHandler({
    map,
  });

  useCorrectionOverlaySync();

  return (
    <div
      className={cn(
        'w-full h-full flex flex-col relative',
        sidebarOpen ? 'sidebar-open' : '',
      )}
    >
      <div ref={mapTargetRef} className="w-full h-full" />
      <MapControls sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <MapInstructionOverlay />

      <MapLayerManager map={map} />
      <FeatureSelectionManager />

      <FieldNotePopup />
      <FeatureInfoPopup />
      <RedlineAttributePopup />

      <MapSearchComponent map={map} />

      <MapSidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <AssetDetailsModal />
    </div>
  );
};

export const MapContainer: React.FC<any> = (props) => {
  return (
    <MapProvider>
      <MapView {...props} />
    </MapProvider>
  );
};
